<template>
  <Modal v-model="visible" title="提示" :footer-hide="true" :mask-closable="false" class="my-modal top" width="400px">
    <div class="text-box">
      <i class="iconfont icontishi"></i>
      编辑产品费率保存后，变更前的费率将成为历史费率，下级机构与团队可查看历史费率，是否继续保存？
    </div>
    <Radio v-model="isCheck">我已知悉，不再提示</Radio>

    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      visible: false,
      isCheck: false,
      data: {}
    };
  },
  watch: {},
  methods: {
    async open(data) {
      this.$emit('save', data);
      // if(localStorage.feeHistoryConfirm) {
      //   this.$emit('save',data);
      //   return;
      // }
      // this.data = data;
      // this.visible = true;
      // this.isCheck = false;
    },
    cancel() {
      this.visible = false;
    },
    ok() {
      if (!this.isCheck) {
        this.$notice.msg('请勾选我已知悉后确定');
        return;
      }
      this.visible = false;
      localStorage.feeHistoryConfirm = '1';
      this.$emit('save', this.data);
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  &.top {
    /deep/ .ivu-modal {
      top: 15vh !important;
    }
  }
  /deep/ {
    .ivu-modal-body {
      font-size: 13px;
    }
    .ivu-modal-footer {
      .ivu-btn {
        width: 80px;
      }
    }
  }
  .text-box {
    padding: 20px 0;
    color: #515c6f;
    i {
      color: #f59853;
      font-size: 13px;
    }
  }
}
</style>
